<template>
  <div class="cart-wrap cart-wrap-add-id-wrap" id="cart-wrap">

    <div class="price-content">
      <div class="price-new">${{productInfo.p_5==2 ? price_sell: productInfo.optFormSpecs.price_sell}}</div>
      <div class="price-old ">${{productInfo.p_5==2 ? price_market : productInfo.optFormSpecs.price_market}}</div>
    </div>
    <div v-if="productInfo.p_5==2">
      <div class="size-list" v-for="(spec_item, index) in productInfo.optFormSpecs.list" :key="index">
      <div class="size-title">{{spec_item.tagTitle}}:</div>
      <div class="size-content"  >
        <div class="size size-spec" @click="specChange('index_'+index, key)" :class="{'color-item' :spec_item.type==2, active: index_detail['index_'+index]==key}"  :style="{background: spec_item.type==2?item.value :''}" v-for=" (item, key) in spec_item.tagDataArr" :key="item.name" >
          {{spec_item.type !=2 ? item.name : ''}}
        </div>
      </div>
    </div>
    </div>
    
    
    <div class="size-list">
      <div class="size-title">Quantity:</div>
      <div class="size-content quantity-content">
        <div class="quantity" @click="countAdd(true)">+</div>
        <input type="number" min="0" max="10" v-model="cart_detail.count" onkeyup="value=value.replace(/[^\d]/g,'')" class="input-count">
        <div class="quantity" @click="countAdd(false)">-</div>
      </div>
    </div>
    <slot></slot>
    <div class="size-list">
      <div class="size-title">shiping:</div>
      <div class="size-content">
        <div class="size">Contact supplier to negotiate shipping details</div>
      </div>
    </div>
    <div class="size-list">
      <div class="size-title">payment：</div>
      <div class="size-content">
        <div class="size"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../../language/index'

export default {
  props:{
    productInfo:{
      type: Object,
      default:()=>{}
    }
  },
  data(){
    return{
    cart_detail:{
      color:0,
      spec:0,
      count: 1
    },
    index_detail:{

    }
  }},
  computed: {
    spec_price(){
      return this.productInfo.optFormSpecs.items ? JSON.parse(this.productInfo.optFormSpecs.items) : null
    },
    index_str(){
      return this.productInfo.optFormSpecs.items && Object.values(this.index_detail).length>0 ? Object.values(this.index_detail).join('/') : null 
    },
    price_sell(){
      return this.spec_price && this.index_str ? this.spec_price[this.index_str].price_sell : 0
    },
    price_market(){
      return this.spec_price && this.index_str ? this.spec_price[this.index_str].price_market : 0
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    }
  },
  mounted(){
    if(this.productInfo.optFormSpecs.list&& this.productInfo.optFormSpecs.list.length>0){
      for(let i =0; i<this.productInfo.optFormSpecs.list.length; i++){
        this.$set(this.index_detail, `index_${i}`, 0)
      }
    }
  },
  methods:{
    specChange(index, key){
      this.index_detail[index] = key
    },
    countAdd(type){
      if(type) this.cart_detail.count++
      else {
        this.cart_detail.count = this.cart_detail.count>1?this.cart_detail.count-1:1
      }
    }
  }
};
</script>

<style scoped lang="scss">
.cart-wrap{
    .price-content{
      display: flex;
      align-items: center;
      .price-new{
        margin-right:10px;
        font-size:16px;
        font-weight: bold;
      }
      .price-old{
        font-size: 14px;
        color: #666;
        text-decoration:line-through;
      }
    }
    .size-list{
      display: flex;
      align-items: center;
      line-height: 40px;
      margin-top:10px;
      .size-title{
        font-size: 14px;
        color: #666;
        margin-right:10px;
        white-space: nowrap;
      }
      .size-content{
        display: flex;
        flex-wrap: wrap;
        &.size-content-wrap{
          margin-bottom:-10px;
        }
        &.quantity-content{
          flex-wrap: nowrap;
        }
        .size{
          margin-right:20px;
          display: flex;
          .pay_icon{
            width:100px;
          }
          &.size-spec{
            padding: 0 10px;
            border: 1px solid #888;
            height:30px;
            line-height: 30px;
            white-space: nowrap;
            margin-bottom:10px;
            cursor: pointer;
            &.active{
              border-color:var(--theme_color);
            }
            &.color-item{
              width:30px;
              height:30px;
              border-radius: 50%;
              &.active{
                border-width: 2px;
                box-shadow:0 0 3px  var(--theme_color);
              }
            }
          }
          
        }
      }
      .quantity-content{
        width:130px;
        border:1px solid #888;
        border-radius: 20px;
        height:36px;
        line-height: 36px;
        .input-count{
          flex: 1;
          text-align: center;
          border:none;
          width:70px;
        }
        .quantity{
          cursor: pointer;
          width:30px;
          text-align: center;
          font-size:20px;
          flex: 0 0 30px;
        }
      }
    }
    .product_button_wrap {
      margin-top:20px;
      display: block;
      align-items: center;
      flex-wrap: wrap;
      padding-left:0 !important;
      .product_advisory_btn {
        width: auto;
        min-width: 150px;
        height: 42px;
        color: #fff;
        font-size: 15px;
        line-height: 42px;
        text-align: center;
        border-radius: 21px;
        transition: background-color .3s;
        text-align: left;
        padding-left: 18px;
        padding-right: 18px;
        cursor: pointer;
        .icon-phonenew {
          font-size: 16px;
        }
        span {
          margin-left: 2px;
        }
      }
    }
  }
  .view_pattern_mb .cart-wrap{
    margin:15px;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_detail/components/cart.vue